import React from "react";
import { ReferenceLine } from "recharts";

import { useScoped } from "~/tools/impulse";
import { theme } from "~/tools/twin-migration";

import { HighlightTimestampCursor, useTimestampCursorState } from "../TimestampCursor";

export const TimestampMarkers: React.FC = () => {
	const timestampCursorState = useTimestampCursorState();

	const markers = useScoped((scope) => timestampCursorState.getAllMarkers(scope), [timestampCursorState]);

	return markers.map(({ timestamp, isHighlighted }) => (
		<ReferenceLine
			key={timestamp}
			shape={(props) => (
				<g>
					<line {...props} />
					<HighlightTimestampCursor el="line" timestamp={timestamp} {...props} stroke="transparent" strokeWidth={7} />
				</g>
			)}
			stroke={isHighlighted ? theme("colors.red.500") : theme("colors.purple.500")}
			x={timestamp}
			zIndex={500}
		/>
	));
};
